import { Exception } from '../exception';

export class RequiredWildcardParamException extends Exception {
}
